import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { fontSize18 } from 'approot/shared/styles/typography.style';
import { spacing24, spacing4 } from 'approot/shared/styles/spacing.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button.style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';

export const CheckAnswerButtonWrapper = styled.div`
  background-color: ${grey1};
  border: 1px solid ${grey4};
  border-radius: ${rem(50)};
  padding: ${rem(spacing4)};
`;

export const CheckAnswerSecondaryButton = styled(SecondaryButton)`
  border-radius: ${rem(50)};
  font-size: ${rem(fontSize18)};
  height: ${rem(50)};
  padding-left: ${rem(spacing24)};
  padding-right: ${rem(spacing24)};
`;

export const CheckAnswerButtonPrimary = styled(PrimaryButton)`
  border-radius: ${rem(50)};
  font-size: ${rem(fontSize18)};
  height: ${rem(50)};
  padding-left: ${rem(spacing24)};
  padding-right: ${rem(spacing24)};
`;
